export const SIZE = {
	SMALL: "small",
	MEDIUM: "medium",
	LARGE: "large"
}

export const ALIGN = {
	LEFT: "left-align",
	CENTER: "center-align",
	RIGHT: "right-align"
}
